/* eslint-disable import/no-cycle */
import { call, put, takeLatest, delay } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import * as types from '../../merchantList/actionTypes';
import { startLoader, stopLoader } from '../../../utility/commonFunction';
import { setMerchantList, setMerchantDetails } from '../../merchantList/actions';
import {
  getMerchantListApi,
  getMerchantDetailsApi,
  updateMerchantStatusApi,
  resendApprovedNotificationToMerchantApi,
} from '../requests/merchantListRequest';

function* getMerchantListHandler(action) {
  if (action.payload?.search) {
    yield delay(1000);
  }

  try {
    yield startLoader('transparent');
    const { data } = yield call(getMerchantListApi, action.payload);
    yield put(setMerchantList(data));
    if (data && !data?.status && data?.errors?.message) {
      yield toast.error(data?.errors?.message);
    }
  } finally {
    yield stopLoader('transparent');
  }
}

function* getMerchantDetailsHandler(action) {
  try {
    yield startLoader('transparent');
    const { data } = yield call(getMerchantDetailsApi, action.payload.id);
    if (data) {
      yield put(setMerchantDetails(data));
    }
  } finally {
    yield stopLoader('transparent');
  }
}

function* updateMerchantStatusHandler(action) {
  const { merchantId, status, reason } = action.payload;
  try {
    yield startLoader('transparent');
    const { data } = yield call(updateMerchantStatusApi, merchantId, { status, reason });
    if (data?.errors?.message) {
      yield toast.error(data.errors.message);
    } else {
      const detailsResponse = yield call(getMerchantDetailsApi, merchantId);
      if (detailsResponse?.data) {
        yield put(setMerchantDetails(detailsResponse.data));
      }
      yield toast.success(data?.message || 'Status updated successfully');
    }
  } finally {
    yield stopLoader('transparent');
  }
}

function* resendApprovedNotificationToMerchantHandler(action) {
  const { merchantId } = action.payload;
  try {
    yield startLoader('transparent');
    const { data } = yield call(resendApprovedNotificationToMerchantApi, merchantId);
    if (data?.errors?.message) {
      yield toast.error(data.errors.message);
    } else {
      yield toast.success(data?.message || 'Onboarding link sent successfully');
    }
  } finally {
    yield stopLoader('transparent');
  }
}

export default function* merchantListSaga() {
  yield takeLatest(types.GET_MERCHANT_LIST, getMerchantListHandler);
  yield takeLatest(types.GET_MERCHANT_DETAILS, getMerchantDetailsHandler);
  yield takeLatest(types.UPDATE_MERCHANT_STATUS, updateMerchantStatusHandler);
  yield takeLatest(types.RESEND_APPROVED_NOTIFICATION_TO_MERCHANT, resendApprovedNotificationToMerchantHandler);
}
